export default __webpack_public_path__ + "static/media/feature6.4fdcfb5c.svg";